import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
The main entry point for the Product Gift Card page

Referenced by the product.gift-certificate.liquid template.
* */
import React from 'react';
import ReactDOM from 'react-dom';
import { giftcardBreadcrumbs } from './components/Breadcrumbs/constants';
import { getVariant, cleanVariants } from './apps/product/GiftCard/utils';
import OVApp from './utils/OVContext';
import ProductGiftCard from './apps/product/GiftCard';
import { jsx as _jsx } from "react/jsx-runtime";
var _window = window,
    shopifyProductData = _window.shopify_product_data;

var render = function render() {
  var urlParams = new URLSearchParams(window.location.search);
  var amount = parseInt(urlParams.get('amount'), 10);
  var variantId = parseInt(urlParams.get('variant'), 10);
  var variants = cleanVariants(shopifyProductData);
  var variant = getVariant(variants, variantId, amount);

  var product = _objectSpread(_objectSpread({}, shopifyProductData), {}, {
    breadcrumbsList: giftcardBreadcrumbs,
    digital: false,
    variant: variant,
    variants: variants
  });

  ReactDOM.render( /*#__PURE__*/_jsx(OVApp, {
    children: /*#__PURE__*/_jsx(ProductGiftCard, _objectSpread({}, product))
  }), document.getElementById('product'));
};

render();